import { useTranslation } from 'react-i18next';
import { Badge } from '../atoms/Badge.js';
import { Card } from '../atoms/Card.js';
import { Typography } from '../atoms/Typography.js';

interface SurveyCardProps {
  id: string;
  title: string;
  status: string;
  createdAt: string;
  respondentCount?: number;
  maxRespondents?: number;
  onClick?: (id: string) => void;
}

const statusVariantMap: Record<string, 'info' | 'success' | 'warning' | 'error' | 'neutral'> = {
  created: 'neutral',
  analyzing: 'info',
  questions_ready: 'info',
  interviewing: 'warning',
  completed: 'success',
  report_generating: 'info',
  report_generated: 'success',
  error: 'error',
  expired: 'neutral',
};

export function SurveyCard({
  id,
  title,
  status,
  createdAt,
  respondentCount = 0,
  maxRespondents = 10,
  onClick,
}: SurveyCardProps) {
  const { t, i18n } = useTranslation('dashboard');

  return (
    <Card
      hover={!!onClick}
      className={onClick ? 'cursor-pointer' : ''}
      onClick={() => onClick?.(id)}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <Typography variant="h5" className="truncate">
            {title}
          </Typography>
          <Typography variant="caption" className="mt-1">
            {new Date(createdAt).toLocaleDateString(i18n.language === 'ja' ? 'ja-JP' : 'en-US')}
          </Typography>
        </div>
        <Badge variant={statusVariantMap[status] ?? 'neutral'}>
          {t(`survey_status.${status}`, status)}
        </Badge>
      </div>
      <div className="mt-3 flex items-center gap-4 text-sm text-neutral-500">
        <span>
          {t('respondents')}: {respondentCount}/{maxRespondents}
        </span>
      </div>
    </Card>
  );
}
